import axios from 'axios';
const DAO_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/produkt';
export async function zapiszKatalogi(id_produkt, katalogi) {
    let res = await axios(DAO_URL, {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: { operacja: "zapiszKatalogi", id_produkt: id_produkt, katalogi: katalogi }
    }).then(response => {
        console.log("status" + response.status + "data:" + JSON.stringify(response.data));
        return response.data;
    }).catch(err => {
        console.log("ass:" + err.message);
        throw err;
    });
    console.log("getKatalogi: res:" + JSON.stringify(res));
    return res;
}
export async function getProduktKatalogi(id_produkt) {
    let res = await axios(DAO_URL, {
        method: 'POST',
        withCredentials: false,
        headers: {
            'Accept': 'application/json'
        },
        data: { operacja: "getProduktKatalogi", id_produkt: id_produkt }
    }).then(response => {
        console.log("status" + response.status + "data:" + JSON.stringify(response.data));
        return response.data;
    }).catch(err => {
        console.log("ass:" + err.message);
        throw err;
    });
    console.log("getKatalogi: res:" + JSON.stringify(res));
    return res;
}